// extracted by mini-css-extract-plugin
export default {"container":"C0-z","list":"D0-z"};